import React from 'react';
import SupplierLayout from '../../layouts/SupplierLayout';
import Settings from '../../components/supplier/Settings';

const SettingsPage = () => {
	return (
		<SupplierLayout>
			<Settings />
		</SupplierLayout>
	);
};

export default SettingsPage;
